import { Component, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {DocumentService} from '../../services/document-service';
import { HttpErrorResponse } from '@angular/common/http';
import {StringUtils} from '../../utils/string-utils';
import {FileUtils} from "../../utils/file-utils";
import {EncompassTreeNode} from '../../model/encompass-tree-node';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { DocumentationTreeComponent } from '../../marketing/documentation-tree/documentation-tree.component';


@Component({
    selector: 'app-ratings-documentation',
    templateUrl: './ratings-documentation.component.html',
    styleUrls: ['./ratings-documentation.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DocumentationTreeComponent, MatProgressSpinner]
})
export class RatingsDocumentationComponent implements OnInit {
  private readonly documentService = inject(DocumentService);


  readonly isBusy = signal<boolean>(undefined!);
  readonly errorMessage = signal<string>(undefined!);
  readonly documentationNodes = signal<EncompassTreeNode[]>([]);
  readonly revitFileNodes = signal<EncompassTreeNode[]>([]);

  ngOnInit(): void {
    this.clearStatus();
    this.getMarketingDocuments();
  }

  private getMarketingDocuments() {
    this.isBusy.set(true);
    this.documentService.getMarketingDocuments().subscribe({
      next: (result) => {
        this.documentationNodes.set(this.filterDocumentation(this.documentService.sortNodes(result.nodes)));
        this.documentService.getRevitFiles().subscribe({
          next: (revit) => {
            this.revitFileNodes.set(this.documentService.sortNodes(revit.nodes));
            this.isBusy.set(false);
          }, error: (error) => this.handleError(error)
        });
      }, error: (error) => this.handleError(error)
    });
  }

  private filterDocumentation(sortedNodes: EncompassTreeNode[]): any[] {
    const documentNodes = [];
    const availableSections = ['Aftermarket Parts', 'Component Cut Sheets', 'Exploded Views', 'Flyers and Brochures', 'Installation, Operation & Maintenance Manuals (IOMs)', 'Mechanical Specifications', 'Physical Data', 'Technical Catalogs'];
    const parentNode = sortedNodes[0];
    const documentationNode = JSON.parse(JSON.stringify(parentNode));
    documentationNode.children = [];
    for (const node of parentNode.children) {
      if (availableSections.indexOf(node.displayName) >= 0) {
        documentationNode.children.push(node);
      }
    }
    documentNodes.push(documentationNode);
    return documentNodes;
  }

  download(node: EncompassTreeNode) {
    this.isBusy.set(true);
    this.errorMessage.set(undefined!);
    this.documentService.downloadMarketingDocument(node.name).subscribe({
      next: (response) => {
        this.isBusy.set(false);
        FileUtils.downloadFile(response, node.displayName);
      }, error: (error) => this.handleError(error)
    });
  }

  downloadRevit(node: EncompassTreeNode) {
    this.isBusy.set(true);
    this.errorMessage.set(undefined!);
    this.documentService.downloadRevitFile(node.name).subscribe({
      next: (response) => {
        this.isBusy.set(false);
        FileUtils.downloadFile(response, node.displayName);
      }, error: (error) => this.handleError(error)
    });
  }

  private clearStatus(): void {
    this.isBusy.set(true);
    this.errorMessage.set(undefined!);
    this.documentationNodes.set([]);
  }

  private handleError(error: HttpErrorResponse): void {
    this.isBusy.set(false);
    this.errorMessage.set(StringUtils.getErrorMessage(error));
  }

}
